import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {Link} from 'react-router-dom'
import Curriculumleft from './Curriculumleft'


const Dualdegree_curriculumEle = () => {
    const calendarsData = [
        // First
        {
            cname: "Environmental and Water Resources Engineering",
            url: "#",
            glow: false,
            SubHeading: false,
        },
        {
            cname: "2019 - Batch Onwards",
            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/DD/DD_EWRE.pdf",
            glow: false,
            SubHeading: true,
        },
        {
            cname: "2018 - Batch",
            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/EWRE_2018_DD Curriculum.pdf",
            glow: false,
            SubHeading: true,
        },
        {
            cname: "2017 - Batch",
            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/EWRE_2017_DD Curriculum.pdf",
            glow: false,
            SubHeading: true,
        },      
        // Second
        {
            cname: "Geotechnical Engineering",
            url: "#",
            glow: false,
            SubHeading: false,
        },
        {
            cname: "2019 - Batch Onwards",
            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/DD/DD_GTE.pdf",
            glow: false,
            SubHeading: true,
        },
        {
            cname: "2018 - Batch",
            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/GT_2018_DD Curriculum.pdf",
            glow: false,
            SubHeading: true,
        },
        {
            cname: "2017 - Batch",
            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/GT_2017_DD Curriculum.pdf",
            glow: false,
            SubHeading: true,
        },



        // third
        {
            cname: "Structural Engineering",
            url: "#",
            glow: false,
            SubHeading: false,
        },

        {
            cname: "2019 - Batch Onwards",
            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/DD/DD_SE.pdf",
            glow: false,
            SubHeading: true,
        },
        {
            cname: "2018 - Batch",
            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/SE_2018_DD Curriculum.pdf",
            glow: false,
            SubHeading: true,
        },
        {
            cname: "2017 - Batch",
            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/SE_2017_DD Curriculum.pdf",
            glow: false,
            SubHeading: true,
        },


        // four
        {
            cname: "Transportation and Infrastructure Engineering",
            url: "#",
            glow: false,
            SubHeading: false,
        },

        {
            cname: "2019 - Batch Onwards",
            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/DD/DD_TIE.pdf",
            glow: false,
            SubHeading: true,
        },
        {
            cname: "2018 - Batch",
            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/TIE_2018_DD Curriculum.pdf",
            glow: false,
            SubHeading: true,
        },
        {
            cname: "2017 - Batch",
            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/TIE_2017_DD Curriculum.pdf",
            glow: false,
            SubHeading: true,
        },


        // fifth
        {
            cname: "Computer Science Engineering",
            url: "#",
            glow: false,
            SubHeading: false,
        },

        {
            cname: "2018 - Batch Onwards",
            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/DD/DD_CSE.pdf",
            glow: false,
            SubHeading: true,
        },
        {
            cname: "2017 - Batch",
            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/CSE_2017_DD_Curriculum.pdf",
            glow: false,
            SubHeading: true,
        },


          // six
        {
            cname: "Signal Processing and Communication",
            url: "#",
            glow: false,
            SubHeading: false,
        },

        {
            cname: "2018 - Batch Onwards",
            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/DD/DD_SPC.pdf",
            glow: false,
            SubHeading: true,
        },
        {
            cname: "2017 - Batch",
            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/SPC_2017_DD_Curriculum.pdf",
            glow: false,
            SubHeading: true,
        },


        // six
        {
            cname: "Mechanical Engineering",
            url: "#",
            glow: false,
            SubHeading: false,
        },

        {
            cname: "2023-2024 onwards",
            url: "https://files.iittp.ac.in/pdfs/curriculum/2023/DD/DD_ME_13-7-2023.pdf",
            glow: false,
            SubHeading: true,
        },
        {
            cname: "2018 - Batch Onwards",
            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/DD/DD_ME_updated.pdf",
            glow: false,
            SubHeading: true,
        },
        {
            cname: "2017 - Batch",
            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/ME_2017_DD Curriculum.pdf",
            glow: false,
            SubHeading: true,
        }   
    ];


    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className='c-left custom-padding-color mb-4'>            
                        <Curriculumleft activeIndex={2} />
                    </Col>

                    <Col md={8} className='c-right mt-2 ps-5'>
                        <h3 className='text-center mb-5'>Dual Degree Curriculum</h3>
                        <h5>Curriculum for Dual Degree Program are listed as below:</h5>
                                <ul className='ms-4 mt-4 fs-5'>
                                    {calendarsData.map((value, index) => {
                                        return (
                                            <li className='c-lineheight3' key={index}>
                                                <span className={`${value.SubHeading ? 'ms-5' : ''}`}></span>
                                                <i className="fas fa-file-pdf me-3 text-danger"></i>
                                                
                                                <Link to={value.url} target="_blank">

                                                    <span className={`${value.glow ? 'test' : ''}`}>
                                                        {value.cname}
                                                    </span>
                                                    
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                    </Col>
                </Row>
            </Container>
        </section>            
     
    );
};


export default Dualdegree_curriculumEle;
